<template>
    <div id="users" class="root">
        <div class="row">
            <div class="col-lg-12 content-body">
                <div class="user-list component-list">
                    <div class="row">
                        <div class="col-lg-12 text-right text-primary pr-lg-4 mb-4">
                            {{ user_pagination.total }} találat
                        </div>
                    </div>
                    <div class="row form-group">
                        <table class="table table-striped">
                            <thead class="thead-dark">
                            <tr>
                                <th scope="col" class="text-left" width="10">#</th>
                                <th scope="col" class="text-left" width="40">Név</th>
                                <th scope="col" class="text-left" width="25">E-mail</th>
                                <th scope="col" class="text-center" width="10">Adminisztrátor</th>
                                <th scope="col" class="text-center" width="10">Módosítva.</th>
                                <th scope="col" width="5"></th>
                            </tr>
                            </thead>
                            <tbody v-if="!loading_status">
                            <tr v-for="item in user_list" v-bind:data="item" v-bind:key="item.id" :class="{'td-deleted' : !item.is_active}">
                                <th scope="row" class="text-left" width="10">
                                    <a v-on:click.stop.prevent="item.is_active ? editUser(item.id) : editUser(null)" class="text-primary">#{{ item.id }}</a>
                                </th>
                                <td class="text-left" width="40">
                                    <a v-on:click.stop.prevent="item.is_active ? editUser(item.ID) : editUser(null)" class="text-primary">{{ item.full_name }}</a>
                                </td>
                                <td class="text-left" width="25">{{ item.email }}</td>
                                <td class="text-center" width="10"><i class="fas fa-check-circle text-success" v-if="item.is_admin"></i></td>
                                <td class="text-center" width="10">{{ item.last_update | formatDate }}</td>
                                <td v-if="user.is_administrator && item.id !== user.id">
                                    <a v-on:click.prevent="item.is_active ? editUser(item.id) : editUser(null)" title="Szerkesztés" v-if="(item.is_active && isAdmin)"><i class="far fa-edit text-success"></i></a>
                                    <a v-on:click.prevent="confirmDelete(item)" title="Törlés" v-if="(item.is_active && isAdmin)"><i class="fas fa-trash-alt text-danger"></i></a>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <loader :loading="loading_status"></loader>
                    <div class="row" v-if="!loading_status">
                        <div class="col-lg-12">
                            <pagination :data="pagination_data"></pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Pagination from "../common/controls/Pagination";
    import Loader from '../common/controls/Loader'
    import { mapGetters, mapActions } from 'vuex'

    export default{
        name: 'users',
        data(){
            return{

            }
        },
        components: {
            Pagination,
            Loader
        },
        computed: {
            ...mapGetters([
                'users',
                'getPagination',
                'userFilters',
                'loading',
                'isAdmin',
                'user'
            ]),
            loading_status: {
                get: function() {
                    return this.loading ? this.loading : false;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            pagination_data: {
                get: function() {
                    return {
                        pagination: this.user_pagination,
                        navigationMethod: this.navigationMethod,
                    }
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            user_list: {
                get: function() {
                    return this.users;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            user_pagination: {
                get: function() {
                    return this.getPagination;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            user_filters: {
                get: function() {
                    return this.userFilters;
                },
                set: function(newVal) {
                    return newVal;
                }
            }
        },
        methods: {
            ...mapActions([
                'deleteUser',
                'getUsers',
            ]),
            navigationMethod(page_id) {
                this.$set(this.user_filters, 'page', page_id);

                this.getUsers({
                    filters: this.user_filters,
                });
            },
            editUser(id) {
                if(id) {
                    this.$router.push({
                        name: 'userDetails',
                        params: {
                            id: id,
                        }
                    });
                }
            },
            confirmDelete(item) {
                let vm = this;
                this.$dialog.confirm('Tényleg szeretné törölni a #'+item.full_name+' felhasználót?', {})
                    .then((dialog) => {
                        vm.deleteUser({
                            list: true,
                            id: item.id,
                        }).then((response) => {
                            dialog.close();
                        });
                    });
            }
        },
        mounted(){

        },
        watch: {
            getPagination: function(newVal) {
                this.user_pagination = newVal;
            },
            pagination_data: function(newVal) {
                this.pagination_data = newVal;
            }
        }
    }
</script>

<style scoped="" lang="scss">
    .user-list {
        overflow: auto;

        tr {
            td > i {
                cursor: pointer;
                padding: 3px;
            }
        }
    }

    @media (max-width: 576px) {
        .user-list {
            overflow: auto;
        }

        .content-title {
            i {
                left: 88% !important;
            }
        }
    }

    button{
        padding-bottom: 7px;
    }
    .product-finder{
        margin-top: 70px;
    }
    table{
        margin-left: 15px;
        margin-right: 15px;
    }
    .action-buttons input[type=checkbox]{
        position: relative;
        top: 1px;
        right: 3px;
    }

    .panel-heading{
        background-color: white;
        color: #42A5F5;
    }

    td i {
        cursor: pointer;
        margin-right: 3px;
    }

    tr {
        td, th {
            a {
                cursor: pointer;
                margin-right: 3px;
            }
        }
    }

</style>
